import {Component, inject} from '@angular/core';
import {KeycloakService} from 'keycloak-angular';
import {Router} from '@angular/router';
import {FloatLabel} from 'primeng/floatlabel';
import {FormsModule} from '@angular/forms';

@Component({
  selector: 'app-login-page',
  standalone: true,
  imports: [
    FormsModule
  ],
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss']
})
export class LoginPageComponent {
  private keycloakService = inject(KeycloakService);
  private router = inject(Router);

  async ngOnInit() {
    try {
      await this.keycloakService.getKeycloakInstance();
      const isAuthenticated = await this.keycloakService.isLoggedIn();
      if (isAuthenticated) {
        this.router.navigate(['/dashboard']);
      }
    } catch (error) {
      console.error('Error checking authentication:', error);
    }
  }

  async login() {
    const isAuthenticated = await this.keycloakService.isLoggedIn();
    if (!isAuthenticated) {
      await this.keycloakService.login();
    } else {
      this.router.navigate(['/dashboard']);
    }
  }
}

